import { render, staticRenderFns } from "./newCompareHarbourDialog.vue?vue&type=template&id=04988101&scoped=true&"
import script from "./newCompareHarbourDialog.vue?vue&type=script&lang=js&"
export * from "./newCompareHarbourDialog.vue?vue&type=script&lang=js&"
import style0 from "./newCompareHarbourDialog.vue?vue&type=style&index=0&id=04988101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04988101",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04988101')) {
      api.createRecord('04988101', component.options)
    } else {
      api.reload('04988101', component.options)
    }
    module.hot.accept("./newCompareHarbourDialog.vue?vue&type=template&id=04988101&scoped=true&", function () {
      api.rerender('04988101', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/newCompareHarbourDialog.vue"
export default component.exports